import * as d3 from 'd3'

export const get_container_instance = ({id, width, height, margin}) => {
    return d3.select(`#${id}`)
        .append('svg')
            .attr('id', 'svg_root')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
        .append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`)
}

export const draw_background_for_screenshot = (instance, { width, height, margin }) => {   
    instance.append('rect')
        .attr('fill', 'white')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .attr('transform', `translate(${-margin.left}, ${-margin.top})`)
}